import { getProjectName } from "@/shared/utils";

const landingViews = import.meta.glob("../views/*/index.vue");

export const getLandingView = () => {
  const projectName = getProjectName();
  if (!projectName) return null;

  const matchedEntry = Object.entries(landingViews).find(([key]) =>
    key.endsWith(`/views/${projectName}/index.vue`)
  );

  if (!matchedEntry) return null;

  return matchedEntry[1];
};

export const hasLandingView = () => !!getLandingView();
